import Content from '../content-interface'

export default class ContractExpirationCanceledHistory implements Content {
  date: string;

  description: string;

  observation: string;

  constructor(obj: any = {}) {
    this.date = obj.date || '';
    this.description = obj.description || '';
    this.observation = obj.observation || '';
  }

  public static of(obj: any = {}): ContractExpirationCanceledHistory {
    return new ContractExpirationCanceledHistory(obj);
  }
}
